import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { SavingsPlan } from "@models/savings_plan";
import { SavingsListViewModel } from "@modules/shared/domain/entities/savings-list-view.model";
import { Tradable } from "@models/interfaces/tradable";
import { TradableWallet } from "@models/interfaces/tradable_wallet";
import { TradableWalletListService } from "@main-services/wallet/tradable_wallet_list.service";
import { TranslationService } from "@core-services/translation.service";

export class SavingsListViewAdapter extends BaseAdapter<SavingsPlan, SavingsListViewModel> {
	public constructor(
		private readonly tradableListService: TradableListService,
		private readonly tradableWalletListService: TradableWalletListService,
		private readonly translationService: TranslationService
	) {
		super();
	}

	public adapt(plan: SavingsPlan): SavingsListViewModel {
		return {
			image: this.getAssetLogo(plan),
			title: this.getAssetTitle(plan),
			value: plan.getFiatAmount(),
			frequency: this.getFrequencyLabel(plan),
			state: plan.getStatus(),
			plan
		};
	}

	private getAssetTitle(plan: SavingsPlan): string {
		const asset = this.getAsset(plan.getCurrencyId());
		return asset?.isToken() ? asset?.getName() : asset?.getSymbol(false, true);
	}

	private getAssetLogo(plan: SavingsPlan): string {
		return this.getAsset(plan.getCurrencyId())?.getLogo();
	}

	private getAsset(tradableId: string): Tradable {
		return this.tradableListService.getItemById(tradableId);
	}

	private getCurrencyId(plan: SavingsPlan): string {
		const wallet = this.getAssetWallet(plan.getAssetWalletId());
		if (!wallet) {
			return "";
		}
		return wallet.getCurrencyId();
	}

	public getAssetWallet(walletId: string): TradableWallet {
		return this.tradableWalletListService.getItemById(walletId, true);
	}

	public getFrequencyLabel(plan: SavingsPlan): string {
		return this.translationService.translate("savings_plan_with_plans_label_" + plan.getFrequency());
	}
}
